import React from 'react';
import './TaxStatutoryDisclosure.css';

export const PROPERTY_PENALTY_LEGAL_REFERENCE = 'महाराष्ट्र ग्रामपंचायत कर व फी (सुधारणा) नियम, २०१५ — नियम २०(३)';
export const PROPERTY_PENALTY_LEGAL_URL = 'https://www.mahaurja.maharashtra.gov.in/Site/Upload/pdf/Govt_of_Maharashtara_Gazette_283.pdf';

export default function TaxStatutoryDisclosure({ compact = false }) {
  return <aside className={`tax-statutory-disclosure${compact ? ' compact' : ''}`} aria-label="मालमत्ता कर दंडाची वैधानिक माहिती">
    <div><strong>वैधानिक पारदर्शकता — नियम २०(३)</strong><span>धोरण आवृत्ती १ · १ एप्रिल २०१६ पासून लागू · मालमत्ता/घरपट्टी चालू आर्थिक वर्षात न भरल्यास आर्थिक वर्ष संपल्यानंतर शिल्लक मूळ करावर दरवर्षी ५% साधा दंड आकारला जातो. दंडावर पुन्हा दंड आकारला जात नाही.</span></div>
    <div><span>हे स्वयंचलित धोरण फक्त मालमत्ता/घरपट्टीला लागू आहे. पाणीपट्टी, आरोग्य, स्वच्छता किंवा व्यवसाय कराला स्वतंत्र वैधानिक आधाराशिवाय हा दंड लागू होत नाही.</span><a href={PROPERTY_PENALTY_LEGAL_URL} target="_blank" rel="noreferrer">अधिकृत नियम पहा</a></div>
  </aside>;
}
